import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "popupContainer" }
const _hoisted_2 = { class: "checkinPopContainer" }
const _hoisted_3 = { class: "headBar" }
const _hoisted_4 = { class: "daysContainer" }

import { ref, PropType, computed } from 'vue'
import StatusPopup from '@/components/common/statusPopup.vue'
import LoadingScreen from '@/components/common/loadingScreen.vue'
import { useI18n } from 'vue-i18n';
import CheckinCard from './checkinCard.vue';
import { checkinClaimRewards, checkinRewardStatus } from '@/api/activity';
import CheckingHistoryPopup from './checkingHistoryPopup.vue';
import { useUserStore } from '@/stores/user';
import CustomHeader from '../../components/common/customHeader.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'checkinPopup',
  props: {
    list: {
        type: Array as PropType<(any)[]>,
        default: () => []
    },
    showIcon: {
        type: Boolean
    },
    isUseFirstRecharge: {
        type: Boolean,
        default: () => false
    }
},
  emits: ['goToVerify'],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props
const userStore = useUserStore()
const emits = __emit
const { t } = useI18n();
const show = ref(false)
const isSuccess = ref(false)
const statusRef = ref()
const toastContent = ref('')
const title = ref('')
const loadingRef = ref()
const configData = ref<any>({})
const reward = computed(() => configData.value?.reward)
const days = computed(() => configData.value?.days)
const configDays = ref<any[]>([])
const totalClaimedCount = ref(0)
const totalClaimedAmount = ref(0)
const historyRef = ref()
const isVerify = ref(false)
const open = (data: any, verify: boolean) => {
    getStatusRecords()
    show.value = true
    isVerify.value = verify
    configData.value = data
    title.value = `R$ ${configData.value.reward} `
}

const close = () => {
    show.value = false
    totalClaimedAmount.value = 0
    totalClaimedCount.value = 0
    configDays.value = []
    configData.value = {}
}

const openHistoryPopup = () => {
    historyRef.value.open()
}
const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const showSuccess = (message: string) => {
    toastContent.value = message;
    isSuccess.value = true;
    statusRef.value.open()
}
const getStatusRecords = () => {
    checkinRewardStatus().then(res => {
        loadingRef.value.close()
        configDays.value = res.data?.days || []
        totalClaimedAmount.value = res.data?.totalClaimedAmount || 0
        totalClaimedCount.value = res.data?.totalClaimedCount || 0

    }).catch(err => {
        loadingRef.value.close()
        showError(err);
    })
}
const getCliam = () => {
    let data = {
        uid: userStore.id
    }
    checkinClaimRewards(data).then(res => {
        loadingRef.value.close()
        showSuccess(res.msg)
        getStatusRecords()
    }).catch(err => {
        loadingRef.value.close()
        showError(err);
    })
}
const goToVerify = () => {
    emits('goToVerify', 1)
}
__expose({
    open,
    close
})

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_van_popup, {
      show: show.value,
      "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event)),
      position: "right",
      style: {
        minWidth: '100%',
        minHeight: '100%',
        background: 'green',
        color: '#fff',
        overflow: 'hidden',
    }
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(CustomHeader, {
            text: title.value + _ctx.$t('activity.everyDay'),
            isPopupCloseBackIcon: true,
            onClosePopup: close,
            "show-history": true,
            onOpenHistoryPopup: openHistoryPopup
          }, null, 8, ["text"]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (!isVerify.value)
                ? (_openBlock(), _createBlock(_component_van_row, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_van_col, {
                        span: "18",
                        class: "headText"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('activity.getSMS', {
                            rewards: reward.value,
                            days: days.value
                        })), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_van_col, {
                        span: "6",
                        class: "verifyBtn"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", {
                            class: "click_btn",
                            onClick: goToVerify
                          }, _toDisplayString(_ctx.$t('activity.verify')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_van_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_van_col, {
                    span: "24",
                    class: "headText"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('activity.login')) + " ", 1),
                      _createElementVNode("span", null, _toDisplayString(totalClaimedCount.value), 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('activity.daysRow')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_van_col, {
                    span: "24",
                    class: "headText"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('activity.recieved')) + " ", 1),
                      _createElementVNode("span", null, _toDisplayString(totalClaimedAmount.value), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_van_row, { class: "colDetails" }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_col, {
                    span: "8",
                    style: {"display":"flex","align-items":"center","justify-content":"center"}
                  }, {
                    default: _withCtx(() => [
                      _cache[1] || (_cache[1] = _createElementVNode("div", {
                        class: "colorText",
                        style: {"background-image":"linear-gradient(45deg, rgb(22 49 134), rgb(40 167 164))"}
                      }, null, -1)),
                      _createElementVNode("div", null, _toDisplayString(_ctx.$t('activityStatus.completed')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_van_col, {
                    span: "8",
                    style: {"display":"flex","align-items":"center","justify-content":"center"}
                  }, {
                    default: _withCtx(() => [
                      _cache[2] || (_cache[2] = _createElementVNode("div", {
                        class: "colorText",
                        style: {"background-image":"linear-gradient(45deg, rgb(89 7 34 / 40%), rgb(235 1 1 / 40%))"}
                      }, null, -1)),
                      _createElementVNode("div", null, _toDisplayString(_ctx.$t('common.notCompleted')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_van_col, {
                    span: "8",
                    style: {"display":"flex","align-items":"center","justify-content":"center"}
                  }, {
                    default: _withCtx(() => [
                      _cache[3] || (_cache[3] = _createElementVNode("div", {
                        class: "colorText",
                        style: {"background-image":"linear-gradient(45deg, rgb(24 106 48), rgb(143 217 39))"}
                      }, null, -1)),
                      _createElementVNode("div", null, _toDisplayString(_ctx.$t('activity.today')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_van_row, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(configDays.value, (item, i) => {
                    return (_openBlock(), _createBlock(_component_van_col, {
                      span: "6",
                      key: i,
                      class: "cardContainer"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(CheckinCard, {
                          amount: reward.value,
                          data: item,
                          onGetClaim: getCliam
                        }, null, 8, ["amount", "data"])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(LoadingScreen, {
      ref_key: "loadingRef",
      ref: loadingRef
    }, null, 512),
    _createVNode(StatusPopup, {
      ref_key: "statusRef",
      ref: statusRef,
      "is-show-success": isSuccess.value,
      content: toastContent.value
    }, null, 8, ["is-show-success", "content"]),
    _createVNode(CheckingHistoryPopup, {
      ref_key: "historyRef",
      ref: historyRef
    }, null, 512)
  ], 64))
}
}

})